(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alva-ceramic-landing"] && !Shopify.designMode) return;
  try {
    

(() => {
  function init(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = 'true';

    root.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#acl-"]');
      if (!link) return;
      const target = root.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      if (target.tagName === 'DETAILS') target.open = true;
      target.scrollIntoView({behavior:'instant',block:'start'});
    });
    const sticky = root.querySelector('.acl-sticky');
    const hero = root.querySelector('.acl-hero');
    const shop = root.querySelector('#acl-shop');
    let heroVisible = true, shopVisible = false;
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if(entry.target === hero) heroVisible = entry.isIntersecting; else shopVisible = entry.isIntersecting; });
        sticky.hidden = heroVisible || shopVisible;
      });
      observer.observe(hero); observer.observe(shop);
    }

  }
  document.querySelectorAll('[data-ceramic-landing]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ceramic-landing]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alva-in-your-kitchen"] && !Shopify.designMode) return;
  try {
    
(()=>{
 function mount(root){
  if(root.dataset.kitchenTabsReady)return;
  const rail=root.querySelector(".alva-kitchen__mobile-tabs");
  if(!rail)return;
  root.dataset.kitchenTabsReady="true";
  const tabs=Array.from(rail.querySelectorAll("[data-kitchen-tab]"));
  const panels=Array.from(root.querySelectorAll("[data-kitchen-panel]"));
  function select(tab,focus){
   const key=tab.dataset.kitchenTab;
   tabs.forEach(button=>{const selected=button===tab;button.setAttribute("aria-selected",String(selected));button.tabIndex=selected?0:-1;});
   panels.forEach(panel=>{panel.hidden=panel.dataset.kitchenPanel!==key;});
   root.querySelectorAll("[data-kitchen-choice]").forEach(choice=>{choice.open=choice.dataset.kitchenChoice===key;});
   if(focus)tab.focus({preventScroll:true});
   const left=tab.offsetLeft,right=left+tab.offsetWidth;
   const target=left<rail.scrollLeft?left:right>rail.scrollLeft+rail.clientWidth?right-rail.clientWidth:rail.scrollLeft;
   if(Math.abs(target-rail.scrollLeft)>1)rail.scrollTo({left:target,behavior:window.matchMedia("(prefers-reduced-motion:reduce)").matches?"auto":"smooth"});
  }
  let drag=null,dragged=false;
  function endDrag(){
   if(!drag)return;
   const id=drag.id;
   drag=null;
   rail.classList.remove("is-dragging");
   if(rail.hasPointerCapture(id))rail.releasePointerCapture(id);
  }
  rail.addEventListener("pointerdown",event=>{
   if(event.pointerType!=="mouse"||event.button!==0)return;
   dragged=false;
   drag={id:event.pointerId,x:event.clientX,left:rail.scrollLeft};
  });
  rail.addEventListener("pointermove",event=>{
   if(!drag||event.pointerId!==drag.id)return;
   if(event.buttons!==1){endDrag();return;}
   const delta=event.clientX-drag.x;
   if(!dragged&&Math.abs(delta)<6)return;
   dragged=true;
   if(!rail.hasPointerCapture(event.pointerId))rail.setPointerCapture(event.pointerId);
   rail.classList.add("is-dragging");
   event.preventDefault();
   rail.scrollLeft=drag.left-delta;
  });
  rail.addEventListener("pointerup",endDrag);
  rail.addEventListener("pointercancel",endDrag);
  rail.addEventListener("lostpointercapture",()=>{drag=null;rail.classList.remove("is-dragging");});
  rail.addEventListener("dragstart",event=>event.preventDefault());
  rail.addEventListener("click",event=>{
   if(dragged&&event.detail>0){dragged=false;event.preventDefault();return;}
   const tab=event.target.closest("[data-kitchen-tab]");
   if(tab&&rail.contains(tab))select(tab,false);
  });
  rail.addEventListener("keydown",event=>{
   const index=tabs.indexOf(event.target);
   if(index<0)return;
   let next;
   if(event.key==="ArrowRight")next=(index+1)%tabs.length;
   else if(event.key==="ArrowLeft")next=(index+tabs.length-1)%tabs.length;
   else if(event.key==="Home")next=0;
   else if(event.key==="End")next=tabs.length-1;
   else return;
   event.preventDefault();select(tabs[next],true);
  });
 }
 document.querySelectorAll(".alva-kitchen").forEach(mount);
 document.addEventListener("shopify:section:load",event=>{event.target.querySelectorAll(".alva-kitchen").forEach(mount);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alva-neat-listicle"] && !Shopify.designMode) return;
  try {
    
function initializeNeat(root) {
 if(root.dataset.initialized)return;root.dataset.initialized='true';
 const select=root.querySelector('[data-neat-variant]');if(!select)return;
 select.addEventListener('change',()=>{
  const option=select.selectedOptions[0];
  root.querySelector('[data-neat-price]').textContent=option.dataset.price;
  const sticky=root.querySelector('[data-neat-sticky-price]');if(sticky)sticky.textContent=option.dataset.shortPrice;
  const image=root.querySelector('#neat-color-image');
  if(image&&option.dataset.image){image.src=option.dataset.image;image.removeAttribute('srcset');}
  const button=root.querySelector('[data-neat-add]');const available=option.dataset.available==='true';
  button.disabled=!available;button.textContent=available?root.dataset.addLabel:root.dataset.soldLabel;
 });
 const form=root.querySelector('.neat-product-form');
 const status=root.querySelector('.neat-form-status');
 if(form&&window.fetch){
  form.addEventListener('submit',async event=>{
   const drawer=document.querySelector('cart-drawer');
   if(!drawer||typeof drawer.show!=='function')return; // native submit fallback
   event.preventDefault();
   const button=form.querySelector('[data-neat-add]');
   if(button.disabled)return;
   const label=button.textContent;button.disabled=true;button.setAttribute('aria-busy','true');button.textContent=root.dataset.busyLabel;
   if(status)status.hidden=true;
   try{
    const body=new FormData(form);body.append('sections','cart-drawer');
    const res=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body});
    if(!res.ok)throw new Error(root.dataset.errorLabel);
    const item=await res.json();
    const cartRes=await fetch('/cart.js',{headers:{'Accept':'application/json'}});
    const cart=await cartRes.json();
    if(item.sections)cart.sections=item.sections;
    root.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:[item],cart,onSuccessDo:'force_open_drawer'}}));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart}}));
    document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',onSuccessDo:'force_open_drawer',cart}}));
    await drawer.show();
   }catch(error){
    if(status){status.textContent=error.message||root.dataset.errorLabel;status.hidden=false;}
   }finally{
    button.disabled=false;button.removeAttribute('aria-busy');button.textContent=label;
   }
  });
 }
}
document.querySelectorAll('[data-neat-section]').forEach(initializeNeat);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-neat-section]').forEach(initializeNeat));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alva-pdp-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle', function(event) {
    const row = event.target;
    if (!row.matches('.alva-pdp-faq__row') || !row.open) return;
    const section = row.closest('.alva-pdp-faq');
    if (!section) return;
    section.querySelectorAll('.alva-pdp-faq__row[open]').forEach(function(otherRow) {
      if (otherRow !== row) otherRow.removeAttribute('open');
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alva-product-details-care"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-alva-topic-link]');
    if (link) {
      const target = document.getElementById(link.dataset.alvaTopicLink);
      if (target && target.tagName === 'DETAILS') target.open = true;
    }
    const report = event.target.closest('[data-alva-material-dialog-open]');
    if (report) {
      const dialog = document.getElementById(report.dataset.alvaMaterialDialogOpen);
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alva-zz-orig-test"] && !Shopify.designMode) return;
  try {
    

(() => {
  function init(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = 'true';

    let buying = false;
    const giftOffers = [
      {pan:Number(root.dataset.panId),lid:Number(root.dataset.lidId),code:'ALVAPANLID129'},
      ...Array.from(root.querySelectorAll('[data-gift-lid]'),button=>({pan:Number(button.dataset.buyVariant),lid:Number(button.dataset.giftLid),code:button.dataset.giftCode}))
    ];
    const status = root.querySelector('.acl-offer-status');
    root.addEventListener('click', async event => {
      const button = event.target.closest('[data-buy-offer], [data-buy-variant]');
      if (!button) return;
      event.preventDefault();
      if (buying) return;
      buying = true;
      status.hidden = true;
      const requestedPan = Number(button.dataset.buyVariant || root.dataset.panId);
      const isGift = button.hasAttribute('data-buy-offer') || button.hasAttribute('data-gift-lid');
      const requestedOffer = isGift ? giftOffers.find(offer => offer.pan === requestedPan) : null;
      const buttons = [...root.querySelectorAll('[data-buy-offer], [data-buy-variant]')].filter(item => !item.disabled);
      buttons.forEach(item => {item.dataset.label=item.textContent;item.disabled=true;item.setAttribute('aria-busy','true');item.textContent=root.dataset.offerBusy;});
      try {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.show !== 'function' || !window.AlvaLidCart) throw new Error(root.dataset.offerError);
        const {cart,added,existingOffer,sections} = await window.AlvaLidCart.addOffer(requestedPan,requestedOffer);
        if (!sections.length || sections.some(id => !cart.sections?.[id])) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart}}));
          await drawer.show();
        } else {
          if (added.length) root.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:added,cart,onSuccessDo:'force_open_drawer'}}));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',onSuccessDo:'force_open_drawer',cart}}));
          if (!added.length) await drawer.show();
        }
        if (isGift && existingOffer && existingOffer.pan !== requestedPan) {
          status.textContent = root.dataset.giftLimit;
          status.hidden = false;
        }
      } catch (error) {
        status.textContent = error.message || root.dataset.offerError;
        status.hidden = false;
        status.focus({preventScroll:true});
      } finally {
        buying=false;
        buttons.forEach(item => {item.disabled=false;item.removeAttribute('aria-busy');item.textContent=item.dataset.label;});
      }
    });

    root.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#acl-"]');
      if (!link) return;
      const target = root.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      if (target.tagName === 'DETAILS') target.open = true;
      target.scrollIntoView({behavior:'instant',block:'start'});
    });
    const sticky = root.querySelector('.acl-sticky');
    const hero = root.querySelector('.acl-hero');
    const shop = root.querySelector('#acl-shop');
    let heroVisible = true, shopVisible = false;
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if(entry.target === hero) heroVisible = entry.isIntersecting; else shopVisible = entry.isIntersecting; });
        sticky.hidden = heroVisible || shopVisible;
      });
      observer.observe(hero); observer.observe(shop);
    }

  }
  document.querySelectorAll('[data-ceramic-landing]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ceramic-landing]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alva-zz-testa"] && !Shopify.designMode) return;
  try {
    

(() => {
  function init(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = 'true';

    let buying = false;
    const giftOffers = [
      {pan:Number(root.dataset.panId),lid:Number(root.dataset.lidId),code:'ALVAPANLID129'},
      ...Array.from(root.querySelectorAll('[data-gift-lid]'),button=>({pan:Number(button.dataset.buyVariant),lid:Number(button.dataset.giftLid),code:button.dataset.giftCode}))
    ];
    const status = root.querySelector('.acl-offer-status');
    root.addEventListener('click', async event => {
      const button = event.target.closest('[data-buy-offer], [data-buy-variant]');
      if (!button) return;
      event.preventDefault();
      if (buying) return;
      buying = true;
      status.hidden = true;
      const requestedPan = Number(button.dataset.buyVariant || root.dataset.panId);
      const isGift = button.hasAttribute('data-buy-offer') || button.hasAttribute('data-gift-lid');
      const requestedOffer = isGift ? giftOffers.find(offer => offer.pan === requestedPan) : null;
      const buttons = [...root.querySelectorAll('[data-buy-offer], [data-buy-variant]')].filter(item => !item.disabled);
      buttons.forEach(item => {item.dataset.label=item.textContent;item.disabled=true;item.setAttribute('aria-busy','true');item.textContent=root.dataset.offerBusy;});
      try {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.show !== 'function' || !window.AlvaLidCart) throw new Error(root.dataset.offerError);
        const {cart,added,existingOffer,sections} = await window.AlvaLidCart.addOffer(requestedPan,requestedOffer);
        if (!sections.length || sections.some(id => !cart.sections?.[id])) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart}}));
          await drawer.show();
        } else {
          if (added.length) root.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:added,cart,onSuccessDo:'force_open_drawer'}}));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',onSuccessDo:'force_open_drawer',cart}}));
          if (!added.length) await drawer.show();
        }
        if (isGift && existingOffer && existingOffer.pan !== requestedPan) {
          status.textContent = root.dataset.giftLimit;
          status.hidden = false;
        }
      } catch (error) {
        status.textContent = error.message || root.dataset.offerError;
        status.hidden = false;
        status.focus({preventScroll:true});
      } finally {
        buying=false;
        buttons.forEach(item => {item.disabled=false;item.removeAttribute('aria-busy');item.textContent=item.dataset.label;});
      }
    });

    root.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#acl-"]');
      if (!link) return;
      const target = root.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      if (target.tagName === 'DETAILS') target.open = true;
      target.scrollIntoView({behavior:'instant',block:'start'});
    });
    const sticky = root.querySelector('.acl-sticky');
    const hero = root.querySelector('.acl-hero');
    const shop = root.querySelector('#acl-shop');
    let heroVisible = true, shopVisible = false;
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if(entry.target === hero) heroVisible = entry.isIntersecting; else shopVisible = entry.isIntersecting; });
        sticky.hidden = heroVisible || shopVisible;
      });
      observer.observe(hero); observer.observe(shop);
    }

  }
  document.querySelectorAll('[data-ceramic-landing]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ceramic-landing]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alva-zz-testb1"] && !Shopify.designMode) return;
  try {
    

(() => {
  function init(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = 'true';

    let buying = false;
    const giftOffers = [
      {pan:Number(root.dataset.panId),lid:Number(root.dataset.lidId),code:'ALVAPANLID129'},
      ...Array.from(root.querySelectorAll('[data-gift-lid]'),button=>({pan:Number(button.dataset.buyVariant),lid:Number(button.dataset.giftLid),code:button.dataset.giftCode}))
    ];
    const status = root.querySelector('.acl-offer-status');
    root.addEventListener('click', async event => {
      const button = event.target.closest('[data-buy-offer], [data-buy-variant]');
      if (!button) return;
      event.preventDefault();
      if (buying) return;
      buying = true;
      status.hidden = true;
      const requestedPan = Number(button.dataset.buyVariant || root.dataset.panId);
      const isGift = button.hasAttribute('data-buy-offer') || button.hasAttribute('data-gift-lid');
      const requestedOffer = isGift ? giftOffers.find(offer => offer.pan === requestedPan) : null;
      const buttons = [...root.querySelectorAll('[data-buy-offer], [data-buy-variant]')].filter(item => !item.disabled);
      buttons.forEach(item => {item.dataset.label=item.textContent;item.disabled=true;item.setAttribute('aria-busy','true');item.textContent=root.dataset.offerBusy;});
      try {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.show !== 'function' || !window.AlvaLidCart) throw new Error(root.dataset.offerError);
        const {cart,added,existingOffer,sections} = await window.AlvaLidCart.addOffer(requestedPan,requestedOffer);
        if (!sections.length || sections.some(id => !cart.sections?.[id])) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart}}));
          await drawer.show();
        } else {
          if (added.length) root.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:added,cart,onSuccessDo:'force_open_drawer'}}));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',onSuccessDo:'force_open_drawer',cart}}));
          if (!added.length) await drawer.show();
        }
        if (isGift && existingOffer && existingOffer.pan !== requestedPan) {
          status.textContent = root.dataset.giftLimit;
          status.hidden = false;
        }
      } catch (error) {
        status.textContent = error.message || root.dataset.offerError;
        status.hidden = false;
        status.focus({preventScroll:true});
      } finally {
        buying=false;
        buttons.forEach(item => {item.disabled=false;item.removeAttribute('aria-busy');item.textContent=item.dataset.label;});
      }
    });

    root.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#acl-"]');
      if (!link) return;
      const target = root.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      if (target.tagName === 'DETAILS') target.open = true;
      target.scrollIntoView({behavior:'instant',block:'start'});
    });
    const sticky = root.querySelector('.acl-sticky');
    const hero = root.querySelector('.acl-hero');
    const shop = root.querySelector('#acl-shop');
    let heroVisible = true, shopVisible = false;
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if(entry.target === hero) heroVisible = entry.isIntersecting; else shopVisible = entry.isIntersecting; });
        sticky.hidden = heroVisible || shopVisible;
      });
      observer.observe(hero); observer.observe(shop);
    }

  }
  document.querySelectorAll('[data-ceramic-landing]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ceramic-landing]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();
})();
